import clsx from 'clsx'
import Cta from '.'
import type { NavigationItemFragment } from '@/lib/types/datocms/graphql/generated'
import Arrow from '@/components/svg/icon/Arrow'

type Props = {
	cta?: NavigationItemFragment
	variant?: 'primary' | 'secondary' | 'tertiary'
	className?: string
	children?: React.ReactNode
	onClick?: () => void
	type?: string
	disabled?: boolean
	backButton?: boolean
}

export default function CtaDefault({
	cta,
	variant = 'primary',
	className,
	onClick,
	children,
	type,
	disabled,
	backButton,
	...props
}: Props & React.HTMLProps<HTMLAnchorElement>) {
	return (
		<Cta
			cta={cta}
			className={clsx(
				'cta group',
				variant === 'primary' &&
					'text-white bg-blue [&_.arrow-container]:text-contrast [&_.arrow-container]:bg-white hover:bg-blue-shade hover:text-white',
				variant === 'secondary' &&
					'text-white bg-blue-dark hover:text-white [&_.arrow-container]:text-contrast [&_.arrow-container]:bg-white hover:bg-contrast',
				variant === 'tertiary' &&
					'text-blue-dark bg-white-frosted-shade  hover:text-blue-dark  [&_.arrow-container]:text-contrast [&_.arrow-container]:bg-white',
				backButton ? 'flex flex-row-reverse p-1.5 pr-5' : 'p-1.5 pl-5',
				className
			)}
			onClick={onClick}
			type={type}
			disabled={disabled}
			{...props}
		>
			<span className="button-label tracking-wider">{cta?.label ?? children}</span>
			<span className="arrow-container">
				<Arrow
					className={clsx(
						'absolute m-auto',
						backButton
							? 'rotate-180 group-hover:animate-arrow-reverse'
							: 'group-hover:animate-arrow'
					)}
					style={
						backButton
							? {
									['--from' as string]: '150%, 0',
									['--to' as string]: '0, 0',
								}
							: {
									['--from' as string]: '0, 0',
									['--to' as string]: '150%, 0',
								}
					}
				/>
				<Arrow
					className={clsx(
						'absolute m-auto',
						backButton
							? 'rotate-180 group-hover:animate-arrow-reverse'
							: 'group-hover:animate-arrow'
					)}
					style={
						backButton
							? {
									['--from' as string]: '0, 0',
									['--to' as string]: '-150%, 0',
								}
							: {
									['--from' as string]: '-150%, 0',
									['--to' as string]: '0, 0',
								}
					}
				/>
			</span>
		</Cta>
	)
}
